export const LOAD_AUTH_TOKEN = "LOAD_AUTH_TOKEN";
